module.exports = __webpack_public_path__ + "62d5b0887aa0ea7a8a3ec1bcc82a1b94.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-6.png
// module id = 2062
// module chunks = 0